export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGOUT = "LOGOUT";
export const LOGIN_FAIL = "LOGIN_FAIL";
// export const AUTH_ERROR = "AUTH_ERROR";
export const SET_LOADING = "SET_LOADING";
// export const CLEAR_ERRORS = "CLEAR_ERRORS";
